// ?debug=true 用の総合問診票定義 — 15+ フィールド型をすべて含む
import painScaleSvg from '@/assets/PainScale.svg'
;(function () {
  window.DEBUG_QST_DEF = {
    title: 'デバッグ用総合問診票 - 全機能テスト',
    description: 'このページではすべてのフィールドタイプをテストできます。\n\n各フィールドの動作を確認してください。',
    submit_button_title: '[デバッグ] 送信テスト',
    label_field: 'ptName',
    welcomemessage: '## ようこそデバッグモードへ\n\nこの問診票では、 すべての主要フィールドをテストできます。',
    // 言語ボタン表示 + 8 主要言語フィルター (項目 3.1 検証)
    translate: 'major',
    // 担当部署 / 担当者 / 責任者 / 問い合わせ先 (項目 2.2 検証)
    dept_in_charge: '内科外来',
    staffs: ['佐藤花子 (看護師)', '田中一郎 (受付)'],
    responsible_person: ['山田太郎 医師'],
    contact: '03-1234-5678 (平日 9:00-17:00)',
    // 終了メッセージ qstDef 側優先 (項目 2.10 検証)
    message: 'ご回答ありがとうございました。 担当者が確認次第ご連絡いたします。',
    fields: [
      { type: 'section', name: 'section1', dispname: 'セクション1: 基本情報', description: 'テキスト入力系のフィールド' },
      { type: 'text', name: 'ptName', dispname: '患者氏名', description: '必須フィールド', required: true, placeholder: '山田太郎', value: '', autocomplete: 'name' },
      // 事前入力済み + readonly (項目 D-2 検証)
      { type: 'text', name: 'ptId', dispname: '患者ID (事前入力 readonly)', placeholder: '12345678', value: 'PRE-0001', readonly: true },
      { type: 'text', name: 'ptPhone', dispname: '電話番号', placeholder: '090-1234-5678', value: '' },
      { type: 'text', name: 'ptEmail', dispname: 'メールアドレス', placeholder: 'example@example.com', value: '' },
      // field.style 検証用 (オレンジ点線枠 + 上余白)
      { type: 'text', name: 'ptHeight', dispname: '身長 (postfix + field.style 例)', postfix: 'cm', value: '', inputmode: 'decimal', style: 'margin-top:16px;padding:8px;border:2px dashed #f59e0b;border-radius:6px;background:#fffbeb' },
      { type: 'text', name: 'ptWeight', dispname: '体重 (postfix 例)', postfix: 'kg', value: '', inputmode: 'decimal' },
      { type: 'textarea', name: 'currentSymptoms', dispname: '現在の症状', description: '現在の症状について詳しく教えてください', required: true, rows: 5, placeholder: '症状を詳しく記入', text: '', instanttext: ['発熱', '咳', '喉の痛み', '頭痛', '倦怠感'] },

      { type: 'subsection', name: 'sub_date', dispname: '日付・時刻フィールド' },
      { type: 'date', name: 'birthDate', dispname: '生年月日', required: true, format: 'YYYY/MM/DD', value: '' },
      { type: 'date', name: 'symptomStartDate', dispname: '症状開始日', value: '' },
      { type: 'time', name: 'visitTime', dispname: '来院希望時刻', format: 'HH:mm', value: '' },

      { type: 'section', name: 'section2', dispname: 'セクション2: 選択肢' },
      { type: 'radio', name: 'ptSex', dispname: '性別', inline: true, selector: '男性|女性|その他', required: true },
      { type: 'radio', name: 'hasPreviousIllness', dispname: '既往歴がありますか?', selector: 'はい|いいえ', required: true },
      { type: 'textarea', name: 'previousIllnessDetail', dispname: '既往歴の詳細', parentname: 'hasPreviousIllness', parentsel: 'はい', text: '' },
      { type: 'checkbox', name: 'symptoms', dispname: '当てはまる症状 (複数選択可)', selector: '発熱|咳|頭痛|腹痛|倦怠感|その他' },
      { type: 'checkbox', name: 'allergies', dispname: 'アレルギー (横並びの複数選択例)', inline: true, selector: '卵|乳|小麦|そば|落花生|えび|かに' },
      { type: 'checkbox', name: 'painType', dispname: '痛みの種類 (checkbox 親 + parentsel | 区切り例)', selector: '頭痛|腹痛|胸痛|背中の痛み', inline: true },
      { type: 'textarea', name: 'painTypeDetail', dispname: '痛みの詳細 (頭痛または腹痛を選んだ時のみ表示)', parentname: 'painType', parentsel: '頭痛|腹痛', text: '', rows: 3 },
      { type: 'checkbox', name: 'riskFactors', dispname: '健康リスク要因 (selectorindex 例)', selector: '喫煙|飲酒|運動不足|睡眠不足', selectorindex: '3|2|1|1', description: '各選択肢に重み (3=最重要, 1=軽微) を割り当てる。 セクション4 の eval で合計します' },

      { type: 'section', name: 'section3', dispname: 'セクション3: スケール' },
      { type: 'painscale', name: 'painLevel', dispname: '痛みの程度', description: '現在の痛みの強さを 0〜10 で', required: false },
      { type: 'bodytemp', name: 'bodyTemp', dispname: '体温 (℃)', value: 365 },
      { type: 'bloodpressure', name: 'bp', dispname: '血圧 (mmHg)', value: { upper: 120, lower: 80 } },
      { type: 'scale', name: 'satisfaction', dispname: '当院の満足度 (1-5、 starttag/endtag 例)', min: 1, max: 5, step: 1, unit: '点', value: 3, starttag: '不満', endtag: '大満足' },

      { type: 'section', name: 'section4', dispname: 'セクション4: 計算式 (eval)' },
      { type: 'eval', name: 'age', dispname: '年齢 (計算)', formula: 'new Date().getFullYear() - parseInt({{birthDate}}.split(\'-\')[0]||0) || 0' },
      { type: 'eval', name: 'tempCelsius', dispname: '体温 (℃)', formula: '((bodyTemp)) / 10' },
      { type: 'warning', name: 'fever', dispname: '発熱注意', formula: '((bodyTemp)) / 10 >= 37.5' },
      { type: 'emergency', name: 'highFever', dispname: '高熱緊急', formula: '((bodyTemp)) / 10 >= 39' },
      { type: 'eval', name: 'nameEcho', dispname: '氏名エコー (%% 生値置換)', formula: '"こんにちは、 " + %%ptName%% + " さん"' },
      { type: 'eval', name: 'bmi', dispname: 'BMI (( )) parseFloat 置換 + 計算', formula: '((ptWeight)) > 0 && ((ptHeight)) > 0 ? Math.round( ((ptWeight)) / ( ((ptHeight))/100 ) / ( ((ptHeight))/100 ) * 10 ) / 10 : ""' },
      { type: 'eval', name: 'riskScore', dispname: 'リスクスコア (%% で .index 配列受け取り、 合計)', formula: '(%%riskFactors.index%% || []).reduce(function(a,b){return parseInt(a)+parseInt(b)}, 0)' },

      { type: 'section', name: 'section5', dispname: 'セクション5: 画像・署名' },
      { type: 'getphoto', name: 'photos', dispname: '症状写真 (最大4枚)', maxPhotos: 4 },
      { type: 'signpad', name: 'signature', dispname: '署名', description: 'タッチペンまたは指で署名してください', required: false },
      { type: 'figure', name: 'painArea', dispname: '痛む部位を図に書き込んでください', baseImgSrc: '/img/男性の全身（人体）のイラスト.png' },

      { type: 'section', name: 'section6', dispname: 'その他' },
      { type: 'note', name: 'note1', description: '**注意:** 入力内容はすべて暗号化されてから送信されます。\n\n医療機関のみが復号できる仕組みになっています。' },
      { type: 'clipart', name: 'clip1', src: painScaleSvg, alt: '痛みスケール参考画像', description: 'clipart 型: 装飾用画像 (痛みスケール VAS の参考)' },
      // field.height 検証 (40% アスペクト比 — 横長埋め込み)
      { type: 'embed', name: 'mapEmbed', dispname: '院所在地マップ (embed + field.height 40%)', height: '40%', src: 'https://www.openstreetmap.org/export/embed.html?bbox=139.7649%2C35.6794%2C139.7716%2C35.6824&layer=mapnik' },
      // separator 描画 (項目 H2 検証 — <hr> 線が表示される)
      { type: 'separator' },
      // field.svgsrc 検証 (生 SVG → data URI)
      { type: 'clipart', name: 'svgClip', svgsrc: '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="60" viewBox="0 0 200 60"><rect width="200" height="60" fill="#dbeafe" rx="8"/><text x="100" y="38" text-anchor="middle" font-size="20" fill="#1e40af" font-family="sans-serif">svgsrc 描画</text></svg>' },
      { type: 'formattedInput', name: 'history', dispname: '既往フォーマット入力', format: '%d 歳のとき %l(風邪|インフルエンザ|肺炎|その他) で %s 病院に通院' },

      // ========================================================================
      // セクション 7: ストレステスト (極端な値・特殊文字・XSS / Firebase 禁止文字 / 多選択肢)
      //   - 文字列長: 200+ 文字、 巨大 description、 改行を含む dispname
      //   - 特殊文字: < > & " ' \ HTML エンティティ、 emoji (絵文字 / ZWJ)、 RTL、 CJK
      //   - XSS attempt: <script> や <img onerror> を description に (DOMPurify で除去されるはず)
      //   - Firebase RTDB 禁止文字 (. $ # / [ ]) を含む field.name (escapeFbRtdbKey で %16進に)
      //   - 多選択肢 (radio 20 個 / checkbox 30 個)、 長い選択肢ラベル
      //   - selectoridx 文字列値 (旧版で文字 index も許容)
      // ========================================================================
      { type: 'section', name: 'section7_stress', dispname: 'セクション7: ストレステスト' },

      // 7.1 極端に長い dispname (1 行で 200+ 文字、 折り返し検証)
      {
        type: 'text',
        name: 'longDispname',
        dispname: '【超長文ラベル】 患者様におかれましては受診前にこちらの問診票への回答にご協力いただきまことにありがとうございます。 以下の質問項目につきましてご記入をお願いいたします。 なお不明な点がございましたら受付までお声がけください。 ご協力よろしくお願いいたします',
        placeholder: '何か入力',
        value: ''
      },

      // 7.1b 長文ラベル + 必須 (required-empty ピンク背景が長文でも正しく回り込むか)
      {
        type: 'text',
        name: 'longDispnameRequired',
        dispname: '【超長文ラベル + 必須】 こちらは入力必須の超長文ラベルです。 折り返しが発生する場合に必須未入力時の ピンク背景がラベル全体を覆うことを確認してください。 ご協力ありがとうございます',
        required: true,
        placeholder: '必須入力',
        value: ''
      },

      // 7.2 description に改行 + Markdown + 巨大本文
      {
        type: 'text',
        name: 'longDescription',
        dispname: '長文 description テスト',
        description: '段落 1: これは **太字** と *斜体* を含む説明文です。\n\n段落 2: 改行を含むテキストが正しくレンダリングされるかを確認します。 リスト:\n\n- 項目 1\n- 項目 2\n- 項目 3\n\n段落 3: `code` インライン、 [リンク](https://www.emuyn.net/) など。\n\n' + '長文充填: あいうえおかきくけこさしすせそたちつてと'.repeat(10),
        value: ''
      },

      // 7.3 特殊文字 (HTML エスケープ、 引用符、 バックスラッシュ)
      {
        type: 'text',
        name: 'specialChars',
        dispname: '特殊文字 <>&"\'\\ テスト',
        description: '入力例: `<script>alert(1)</script>` や `\' OR 1=1 --` などの注入文字列を入れて確認',
        placeholder: '<>&"\'\\',
        value: ''
      },

      // 7.4 emoji / ZWJ / RTL (右から左) / CJK / 結合文字
      {
        type: 'text',
        name: 'unicodeChars',
        dispname: 'Unicode 試験 🏥👨‍⚕️👩🏻‍⚕️ العربية 한국어 中文 ひらがな カタカナ',
        description: 'RTL (アラビア語) + emoji 結合 + CJK 混在表示の検証',
        value: ''
      },

      // 7.5 XSS 試行 (DOMPurify でサニタイズされるはず — 画面に alert が出ないこと)
      //     img.src は 1x1 透明 GIF の data URL — 残っても 404 を出さないため
      {
        type: 'text',
        name: 'xssAttempt',
        dispname: 'XSS 試験',
        description: '<script>window.__xssTest__=true</script><img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" onerror="window.__xssTest2__=true" alt="">サニタイズされて何も起きないはず。 console で window.__xssTest__ を確認 → undefined であれば OK',
        value: ''
      },

      // 7.6 Firebase RTDB 禁止文字を name に (. $ # / [ ]) → escapeFbRtdbKey で %16進に escape されて送信される
      {
        type: 'text',
        name: 'name.with$special#chars/[brackets]',
        dispname: 'name に Firebase 禁止文字 (. $ # / [ ])',
        description: '送信時に escapeFbRtdbKey で %2E %24 %23 %2F %5B %5D に変換されることを payload で確認',
        value: ''
      },

      // 7.7 radio: 20 選択肢 + 各ラベルが長文
      {
        type: 'radio',
        name: 'manyRadio',
        dispname: '多数選択肢 radio (20 項目、 長いラベル混在)',
        selector: [
          '選択肢 1: 短',
          '選択肢 2: 中くらいの長さのラベル',
          '選択肢 3: 非常に長いラベルで折り返しが発生するかどうかを確認するための文字列',
          '選択肢 4', '選択肢 5', '選択肢 6', '選択肢 7', '選択肢 8',
          '選択肢 9', '選択肢 10', '選択肢 11', '選択肢 12', '選択肢 13',
          '選択肢 14', '選択肢 15', '選択肢 16', '選択肢 17', '選択肢 18',
          '選択肢 19', '選択肢 20 (最後)'
        ]
      },

      // 7.7b 必須 radio + 長文選択肢混在 (required-empty 背景が縦並びでも全体に効くか)
      {
        type: 'radio',
        name: 'requiredLongRadio',
        dispname: '必須 radio + 長文選択肢',
        required: true,
        selector: [
          '短い選択肢 1',
          '中くらいの長さの選択肢 2 (medium length option)',
          'とても長い説明文を含む選択肢 3 — 折り返しが発生するほどの長さがあるラベル',
          'もうひとつ長い選択肢 4: こちらも改行が起きるくらい長い文章になっています'
        ]
      },

      // 7.7c 必須 radio inline + 長文選択肢混在
      {
        type: 'radio',
        name: 'requiredLongRadioInline',
        dispname: '必須 radio inline + 長文選択肢',
        required: true,
        inline: true,
        selector: ['同意する (これも長めの選択肢ラベル例)', '同意しない', '判断保留']
      },

      // 7.7d 必須 checkbox + 多選択肢 (required-empty 背景が縦並びでも全体に効くか)
      {
        type: 'checkbox',
        name: 'requiredCheckbox',
        dispname: '必須 checkbox (1 つ以上選択必須)',
        required: true,
        selector: '選択肢 A|選択肢 B (やや長め)|選択肢 C|選択肢 D'
      },

      // 7.8 checkbox: 30 選択肢、 inline で wrap 確認
      {
        type: 'checkbox',
        name: 'manyCheckbox',
        dispname: '多数 checkbox inline (30 項目)',
        inline: true,
        selector: 'A|B|C|D|E|F|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|あ|い|う|え'
      },

      // 7.9 selector に特殊文字を含む選択肢 (パイプ区切り構造を壊しかねない値)
      {
        type: 'radio',
        name: 'specialSelectorValues',
        dispname: '選択肢に特殊文字 (引用符・改行・タブ)',
        selector: ['"二重引用符"を含む', "'シングル'を含む", '\\バックスラッシュ\\', '空白 (NBSP)を含む', 'タブ\t含み'],
        description: 'tab や NBSP が表示されるか、 送信 payload に保持されるかを確認'
      },

      // 7.10 selectoridx を文字列 index で (数字以外もキー化されるか)
      {
        type: 'radio',
        name: 'stringIdxSelector',
        dispname: 'selectoridx 文字列 index 例',
        selector: 'りんご|みかん|ぶどう',
        selectoridx: 'A|B|C'
      },

      // 7.11 数値スケールの極端な範囲 (max - min = 10000)
      { type: 'scale', name: 'wideRange', dispname: '極端なスケール (min=0, max=10000, step=50)', min: 0, max: 10000, step: 50, value: 5000, unit: '万円' },

      // 7.12 formattedInput に多数 (%d %s %l %r 全部混在 + 改行)
      {
        type: 'formattedInput',
        name: 'complexFormatted',
        dispname: '複雑な formattedInput',
        format: '%d 年 %d ヶ月の経験で %s 科を %l(週 1|週 2-3|週 4-5|毎日) 担当、 主に %r(外来|入院|手術) を %d 件/月',
        placeholder: '0|施設名|選択'
      },

      // 7.13 巨大 instanttext リスト (textarea ボタン 20 個)
      {
        type: 'textarea',
        name: 'manyInstant',
        dispname: 'instanttext 大量 (20 ボタン)',
        rows: 3,
        text: '',
        instanttext: ['頭痛', '腹痛', '発熱', '咳', '鼻水', '喉の痛み', '倦怠感', '関節痛', '吐き気', '下痢', '便秘', '不眠', '食欲不振', '体重減少', '視力低下', '聴力低下', '味覚異常', '嗅覚異常', 'しびれ', '動悸']
      },

      // 7.14 全角数値入力 → 半角変換 (旧版 han2zen 検証)
      {
        type: 'text',
        name: 'fullWidthNumber',
        dispname: '全角→半角変換テスト (inputmode=numeric)',
        description: '値に「０１２３４５」 と全角で入れて他フィールドへフォーカス移動 → 「012345」 に変換されること',
        inputmode: 'numeric',
        value: ''
      },

      // 7.15 dispname なし (ラベル省略 — フィールドだけ表示)
      {
        type: 'text',
        name: 'noDispname',
        description: 'dispname を省略したフィールド (description だけ表示されるはず)',
        placeholder: 'ラベル無し',
        value: ''
      },

      // 7.16 description が配列 (旧版 getJoined: 配列なら \n で join)
      {
        type: 'text',
        name: 'descAsArray',
        dispname: 'description が配列のテスト',
        description: ['1 行目: 配列の最初', '2 行目: 配列の 2 番目', '3 行目: 配列の 3 番目'],
        value: ''
      }
    ]
  };
})();
